/**
 * Knowledge Sources API
 * Manages knowledge sources for agent RAG
 */

import { BaseApiClient } from "./base";

// ========== Types ==========

export interface KnowledgeSource {
  id: string;
  workspace_id: string;
  type: string;
  name: string;
  config: Record<string, any>;
  created_at: string;
  updated_at: string;
}

export interface QueryKnowledgeRequest {
  query: string;
  limit?: number;
}

export interface QueryKnowledgeResult {
  docTitle: string;
  relevanceScore: string;
  content: string;
  link: string;
}

export type QueryKnowledgeResponse = QueryKnowledgeResult[];

// ========== API Client ==========

class KnowledgeApiClient extends BaseApiClient {
  /**
   * List all knowledge sources for the workspace
   */
  async list(): Promise<KnowledgeSource[]> {
    return this.request<KnowledgeSource[]>("/knowledge");
  }

  /**
   * Query a knowledge source
   */
  async query(
    knowledgeSourceId: string,
    data: QueryKnowledgeRequest
  ): Promise<QueryKnowledgeResponse> {
    return this.request<QueryKnowledgeResponse>(`/knowledge/${knowledgeSourceId}/query`, {
      method: "POST",
      body: JSON.stringify(data)
    });
  }
}

export const knowledgeApi = new KnowledgeApiClient();
